/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Bc_Records_To_MatchInputs */

const en_queue_bc_records_to_match = /** @type {(inputs: Queue_Bc_Records_To_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business Central records to match`)
};

/**
* | output |
* | --- |
* | "Business Central records to match" |
*
* @param {Queue_Bc_Records_To_MatchInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_bc_records_to_match = /** @type {((inputs?: Queue_Bc_Records_To_MatchInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Bc_Records_To_MatchInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_bc_records_to_match(inputs)
});